import { en } from './en'

export const fr = {
	...en,
  meta: {
    title: 'AuthFlow™ - Authentification simple par e-mail/mot de passe avec jetons JWT',
    description: 'Authentification fiable par e-mail/mot de passe avec jetons JWT pour les applications web modernes. Contrairement aux plateformes complexes, nous nous concentrons sur ce qui fonctionne : une connexion sécurisée et simple à laquelle les développeurs peuvent se fier.',
  },
	nav: {
		home: 'Accueil',
		features: 'Fonctionnalites',
		pricing: 'Tarifs',
		compare: 'Comparer',
		contact: 'Contact',
		getStarted: 'Commencer',
		signIn: 'Se connecter',
	},
	hero: {
		badge: 'Fiable pour les equipes DevSecOps dans le monde',
		title: 'Authentification',
		subtitle: 'bien faite',
		description: 'La meilleure, la plus rapide et la plus sure authentification e-mail/mot de passe. Au lieu de plateformes trop complexes, nous nous concentrons sur l\'essentiel: une authentification JWT securisee qui fonctionne vraiment.',
		startTrial: 'Demarrer l\'essai gratuit',
		getStarted: 'Commencer',
			trialNote: 'Aucune carte bancaire requise • 10 Utilisateurs Actifs Mensuels gratuits',
		metrics: {
			firstIntegrationValue: '5 min',
			firstIntegrationLabel: 'jusqu\'a la premiere integration',
			predictableSessionsValue: 'JWT',
			predictableSessionsLabel: 'sessions qui restent previsibles',
			noMazeValue: 'Zero labyrinthe',
			noMazeLabel: 'pour les equipes qui veulent juste un auth fiable',
		},
		missionControlLabel: 'Centre de controle auth',
		missionControlTitle: 'Authentifier les utilisateurs, sans labyrinthe',
		missionControlStatus: 'Stable',
		sessionLayer: 'Couche de session',
		emailPasswordSignIn: 'Connexion e-mail/mot de passe',
		roleAwareVerification: 'Verification adaptee aux roles',
		validated: 'valide',
		live: 'en direct',
		integrationShapeLabel: 'Forme de l\'integration',
		integrationShapeValue: 'Petite API, flux clair',
		forTeamsLabel: 'Pour les equipes',
		forTeamsValue: 'Livrer le produit, pas des projets IAM',
	},
	cta: {
		title: 'Pret a ajouter une authentification fiable?',
		description: 'Rejoignez les equipes qui choisissent une authentification e-mail/mot de passe simple et efficace avec JWT. Demarrez votre essai gratuit aujourd\'hui.',
		startTrial: 'Demarrer l\'essai gratuit',
	},
	dashboard: {
		title: 'Tableau de bord',
		users: 'Utilisateurs',
		activity: 'Activite',
		settings: 'Parametres',
		logout: 'Se deconnecter',
		profileSettings: 'Parametres du profil',
		activityLog: 'Journal d\'activite',
		welcome: 'Bienvenue sur votre tableau de bord',
		welcomeBack: 'Bon retour, {name}. Voici ce qui se passe avec votre service d\'authentification.',
		totalUsers: 'Utilisateurs totaux',
		activeUsers: 'Utilisateurs actifs',
		totalLogins: 'Connexions totales',
		recentActivity: 'Activite recente',
		noRecentActivity: 'Aucune activite recente',
		userSettings: 'Parametres utilisateur',
		organizationOwnerCannotBeManaged: 'Le proprietaire de l\'organisation ne peut pas etre gere',
		configureSettings: 'Configurer les parametres',
		hereIsWhatsHappening: 'Voici ce qui se passe avec votre service d\'authentification.',
		fromLastMonth: 'depuis le mois dernier',
		monthlyLogins: 'Connexions mensuelles',
		successRate: 'Taux de reussite',
		latestAuthEvents: 'Derniers evenements d\'authentification et mises a jour systeme',
		viewAllActivity: 'Voir toute l\'activite',
		userManagement: 'Gestion des utilisateurs',
		manageApplicationUsers: 'Gerez les utilisateurs de votre application',
		viewAllUsers: 'Voir tous les utilisateurs',
		apiKeys: 'Cles API',
		manageApiKeys: 'Gerez vos cles API d\'authentification',
		systemStatus: 'Statut systeme',
		authenticationApi: 'API d\'authentification',
		operational: 'Operationnel',
		userManagementService: 'Gestion des utilisateurs',
		searchUsers: 'Rechercher des utilisateurs...',
		all: 'Tous',
		active: 'Actifs',
		inactive: 'Inactifs',
		lastLogin: 'Derniere connexion',
		never: 'Jamais',
		admin: 'Admin',
		owner: 'Proprietaire',
		noUsersFound: 'Aucun utilisateur ne correspond a vos criteres',
		noUsers: 'Aucun utilisateur trouve',
		for: 'pour',
		noApiKeyFound: 'Aucune cle API trouvee',
		hideApiKey: 'Masquer la cle API',
		showApiKey: 'Afficher la cle API',
		created: 'Cree',
		success: 'Succes',
		warning: 'Avertissement',
		info: 'Info',
		system: 'Systeme',
		justNow: 'a l\'instant',
		minutesAgo: 'minutes plus tot',
		hoursAgo: 'heures plus tot',
		daysAgo: 'jours plus tot',
		notifications: 'Notifications',
		billingReminder: 'Rappel de facturation',
		noNewNotifications: 'Aucune nouvelle notification',
		logOut: 'Se deconnecter',
	},
	about: {
		title: 'A propos d\'AuthFlow™ - Experts en authentification e-mail/mot de passe simple',
		description: 'Decouvrez la mission d\'AuthFlow™: fournir une authentification e-mail/mot de passe fiable avec des tokens JWT.',
		keywords: ['authentification email mot de passe', 'entreprise authentification JWT', 'experts authentification', 'authentification simple', 'entreprise connexion securisee', 'authentification developpeur', 'authentification fiable', 'authentification basee token', 'securite web app', 'plateforme authentification'],
		ogTitle: 'A propos d\'AuthFlow™ - Experts en authentification e-mail/mot de passe simple',
		ogDescription: 'Decouvrez notre mission pour fournir une authentification e-mail/mot de passe fiable avec JWT.',
		hero: {
			badge: 'Fonde en 2023',
			title: 'Construire le futur de',
			titleAccent: 'l\'authentification simple',
			description: 'Notre mission est de rendre l\'authentification e-mail/mot de passe avec JWT accessible a tous les developpeurs.',
		},
		mission: {
			title: 'Notre mission',
			description1: 'Democratiser une authentification securisee basee sur des tokens, simple a implementer et maintenir.',
			description2: 'Nous priorisons la confidentialite et la conformite by design.',
			description3: 'Nous permettons aux developpeurs de se concentrer sur leurs produits, pas sur une auth surcomplexe.',
		},
		vision: {
			title: 'Notre vision',
			description1: 'Un monde ou l\'authentification est simple et fiable.',
			description2: 'Nous construisons une infrastructure d\'authentification securisee et simple, sur laquelle les developpeurs peuvent compter.',
		},
		values: {
			title: 'Nos valeurs',
			subtitle: 'Les principes qui guident tout ce que nous faisons.',
			reliableSecurity: {
				title: 'Securite fiable',
				description: 'Des pratiques de securite eprouvees qui fonctionnent, sans complexite inutile.',
			},
			developerFirst: {
				title: 'API orientee developpeurs',
				description: 'Nous visons des outils intuitifs, bien documentes et agreables a utiliser.',
			},
			communityDriven: {
				title: 'Guide par la communaute',
				description: 'Notre roadmap evolue grace au feedback des developpeurs et besoins terrain.',
			},
		},
		team: {
			title: 'Notre equipe',
			subtitle: 'Les personnes passionnees qui construisent le futur de l\'authentification.',
			alex: { initials: 'AJ', name: 'Alex Johnson', role: 'CEO & Co-Founder', bio: 'Ancien DevSecOps dans une grande institution financiere multinationale.' },
			sarah: { initials: 'SC', name: 'Sarah Chen', role: 'CTO & Co-Founder', bio: 'Architecte full-stack avec plus de 10 ans d\'experience en systemes d\'authentification fiables.' },
			marcus: { initials: 'MR', name: 'Marcus Rodriguez', role: 'Head of Product', bio: 'Leader produit axe sur l\'experience developpeur et les systemes de connexion simples.' },
		},
		stats: {
			title: 'AuthFlow™ en chiffres',
			developers: 'Developpeurs qui nous font confiance',
			authentications: 'Authentifications mensuelles',
			uptime: 'Disponibilite',
			monitoring: 'Monitoring securite',
		},
		cta: {
			title: 'Rejoignez notre mission',
			description: 'Pret a participer a la revolution de l\'authentification?',
			getStarted: 'Commencer gratuitement',
			contactUs: 'Nous contacter',
		},
		breadcrumb: { company: 'Entreprise', aboutUs: 'A propos' },
	},
	getStarted: {
		...en.getStarted,
		title: 'AuthFlow™ Commencer - Guide d\'installation authentification e-mail/mot de passe | Integration API JWT',
		description: 'Guide complet pour implementer l\'authentification e-mail/mot de passe avec AuthFlow™. Configurez un login JWT securise en quelques minutes.',
		keywords: ['configuration authentification', 'authentification email mot de passe', 'integration JWT', 'guide login securise', 'authentification developpeur', 'tutoriel API auth', 'authentification token', 'guide API auth'],
		ogTitle: 'AuthFlow™ Commencer - Guide d\'installation authentification e-mail/mot de passe | Integration API JWT',
		ogDescription: 'Mettez en place l\'authentification e-mail/mot de passe avec AuthFlow™ et des tokens JWT en quelques minutes.',
		breadcrumb: { resources: 'Ressources', getStarted: 'Commencer' },
		hero: {
			...en.getStarted.hero,
			badge: 'Guide de configuration rapide',
			title: 'Demarrez avec',
			titleAccent: 'l\'authentification e-mail/mot de passe',
			description: 'Ajoutez un login e-mail/mot de passe securise a votre application en quelques minutes.',
			createAccount: 'Creer un compte gratuit',
		},
		steps: {
			...en.getStarted.steps,
			title: 'Trois etapes simples pour securiser l\'authentification e-mail/mot de passe',
			subtitle: 'Integrez les endpoints AuthFlow™ dans votre backend.',
			step1: { ...en.getStarted.steps.step1, title: 'Creez votre compte', description: 'Inscrivez-vous sur AuthFlow™ et creez votre premier projet.', signUp: 'Inscription gratuite', viewDemo: 'Voir la demo' },
			step2: { ...en.getStarted.steps.step2, title: 'Integrez les endpoints auth', description: 'Utilisez nos endpoints /auth depuis votre backend.' },
			step3: { ...en.getStarted.steps.step3, title: 'Ajoutez l\'authentification', description: 'Connectez votre app et commencez a authentifier vos utilisateurs.', quickStart: 'Demarrage rapide', fullDocumentation: 'Documentation complete' },
		},
		apiDocs: {
			...en.getStarted.apiDocs,
			title: 'Guide technique des endpoints API /auth',
			subtitle: 'Documentation technique complete pour l\'integration backend AuthFlow™.',
		},
		features: {
			...en.getStarted.features,
			title: 'Ce que vous obtenez avec l\'authentification e-mail/mot de passe',
			subtitle: 'Branchez les endpoints, nous gerons les sessions JWT fiables.',
		},
		cta: {
			...en.getStarted.cta,
			title: 'Pret a ajouter une authentification e-mail/mot de passe fiable?',
			description: 'Demarrez votre essai gratuit aujourd\'hui et activez JWT avant la fin de journee.',
			createAccount: 'Creer un compte gratuit',
			talkToSales: 'Contacter les ventes',
		},
		parameters: 'Parametres',
		response: 'Reponse',
		example: 'Exemple',
		runFailureScenario: 'Executer en scenario d\'echec',
		failureScenarioOn: 'Scenario d\'echec : actif',
		running: 'Execution...',
		runCurlConsole: 'Executer cURL dans la console',
		copied: 'Copie !',
		copyCurl: 'Copier curl',
		copyBackendExample: 'Copier le code backend',
		required: 'obligatoire',
		optional: 'optionnel',
		consoleRunning: 'Console en cours...',
		consoleDemoTitle: 'Demo console Linux',
		consoleShellLabel: 'bash -- Console AuthFlow™',
		notesTitle: 'Notes',
		endpointContent: {
			session: {
				fooBar: {
					summary: 'Genere un token anti-abus a courte duree avant sign-up ou login.',
					params: {
						identity: 'Adresse e-mail de l\'utilisateur auth.',
						apiKey: 'Cle API organisation depuis le dashboard owner AuthFlow™.',
						role: 'Role RBAC encode dans le token temporaire. Defaut: user.',
					},
					notes: {
						expires: 'Ce token expire apres 45 secondes.',
						freshToken: 'Recuperez un token fooBar frais juste avant sign-up ou login.',
					},
				},
				signUp: {
					summary: 'Cree un nouvel utilisateur auth dans l\'organisation owner.',
					params: {
						foobar: 'Token anti-abus temporaire retourne par /auth/fooBar.',
						email: 'Adresse e-mail utilisateur.',
						password: 'Mot de passe respectant {passwordRule}.',
						fullname: 'Nom complet de l\'utilisateur auth.',
						role: 'Role RBAC de l\'utilisateur dans votre application.',
						apiKey: 'Cle API organisation.',
						disclaimed: 'Valeur booleenne stockee avec l\'utilisateur. La collection utilise true.',
					},
					notes: {
						successToken: 'Un sign-up reussi retourne immediatement un session token.',
						duplicateRole: 'Si le meme email+role existe deja, l\'API repond 409.',
					},
				},
				login: {
					summary: 'Authentifie un utilisateur auth et retourne un session token ou un challenge 2FA.',
					params: {
						foobar: 'Token anti-abus temporaire retourne par /auth/fooBar.',
						email: 'Adresse e-mail utilisateur.',
						password: 'Mot de passe utilisateur.',
						apiKey: 'Cle API organisation.',
						role: 'Role utilisateur pour le login RBAC.',
					},
					notes: {
						tempTokenInsteadOfToken: 'Quand 2FA est active, login retourne tempToken au lieu de token.',
						exchangeThrough2fa: 'Le tempToken est ensuite echange via un endpoint de verification /auth/2fa.',
					},
				},
				validate: { summary: 'Valide un session token pour un utilisateur auth.', params: { sessionToken: 'Session token JWT RS512.', email: 'Adresse e-mail utilisateur.' } },
				me: { summary: 'Retourne le profil auth-user courant pour une session valide.', params: { sessionToken: 'Session token JWT RS512.' } },
				logout: { summary: 'Deconnecte l\'utilisateur auth courant.', params: { sessionToken: 'Session token JWT RS512.', email: 'Adresse e-mail utilisateur.' } },
			},
			passwordManagement: {
				forgotPassword: { summary: 'Demande un e-mail de reset mot de passe pour un auth-user (reponse anti-enumeration).', params: { email: 'Adresse e-mail auth-user.', apiKey: 'Cle API organisation.', role: 'Role auth-user. Defaut user.' } },
				resetPassword: { summary: 'Reinitialise le mot de passe d\'un auth-user avec un token valide.', params: { token: 'Token de reset depuis le lien e-mail.', newPassword: 'Nouveau mot de passe respectant {passwordRule}.' } },
				changePassword: { summary: 'Change le mot de passe de l\'auth-user authentifie.', params: { sessionToken: 'Session token JWT RS512 courant.', email: 'E-mail encode dans le token de session.', oldPassword: 'Mot de passe actuel de confirmation.', newPassword: 'Nouveau mot de passe respectant {passwordRule}.' } },
			},
			emailVerification: {
				verifyEmail: {
					summary: 'Verifie l\'e-mail d\'un auth-user avec le token envoye par e-mail AuthFlow™.',
					params: { token: 'Token de verification depuis le lien e-mail.' },
					notes: { openedFromEmail: 'Cet endpoint est generalement ouvert en cliquant le lien de verification dans l\'e-mail.', frontendHostedProxy: 'AuthFlow™ prend aussi en charge une verification frontend-hosted via /verify-email.' },
				},
				resendVerifyEmail: { summary: 'Renvoye l\'e-mail de verification quand le compte n\'est pas encore verifie.', params: { foobar: 'Token temporaire retourne par /auth/fooBar.', email: 'Adresse e-mail auth-user.', apiKey: 'Cle API organisation.', role: 'Role auth-user. Defaut user.' } },
			},
			twoFactor: {
				enable: { summary: 'Genere un secret TOTP et un QR code pour un auth-user.', params: { sessionToken: 'Session token courant.', email: 'E-mail auth-user.', apiKey: 'UUID organisation.', role: 'Role auth-user.' } },
				verifySetup: { summary: 'Verifie le code TOTP initial et active la 2FA.', params: { sessionToken: 'Session token courant.', email: 'E-mail auth-user.', apiKey: 'UUID organisation.', role: 'Role auth-user.', totpCode: 'Code a six chiffres de l\'application authenticator.', secret: 'Secret TOTP retourne par /auth/2fa/enable.' } },
				disable: { summary: 'Desactive la 2FA TOTP pour un auth-user.', params: { sessionToken: 'Session token courant.', email: 'E-mail auth-user.', apiKey: 'UUID organisation.', role: 'Role auth-user.', password: 'Mot de passe actuel.' } },
				verify2fa: { summary: 'Echange un tempToken de login et un code TOTP contre un session token.', params: { tempToken: 'tempToken retourne par /auth/login quand 2FA est active.', email: 'E-mail auth-user.', apiKey: 'UUID organisation.', role: 'Role auth-user.', totpCode: 'Code authenticator a six chiffres.' } },
				backupEmail: { summary: 'Envoie un OTP e-mail de secours via un tempToken de login.', params: { tempToken: 'tempToken retourne par /auth/login.', email: 'E-mail auth-user.', apiKey: 'UUID organisation.', role: 'Role auth-user.' } },
				verifyEmailOtp: { summary: 'Echange un OTP e-mail contre un session token.', params: { email: 'E-mail auth-user.', apiKey: 'UUID organisation.', role: 'Role auth-user.', emailOtp: 'Code a six chiffres recu par e-mail.' } },
				recoveryCodes: { summary: 'Regenere les recovery codes d\'un auth-user.', params: { sessionToken: 'Session token courant.', email: 'E-mail auth-user.', apiKey: 'UUID organisation.', role: 'Role auth-user.', password: 'Mot de passe actuel.' } },
				verifyRecovery: { summary: 'Echange un recovery code contre un session token.', params: { email: 'E-mail auth-user.', apiKey: 'UUID organisation.', role: 'Role auth-user.', recoveryCode: 'Un des recovery codes a 8 caracteres precedemment fournis.' } },
			},
			environment: {
				baseUrl: 'Origine API publique.',
				apiKey: 'Cle API dashboard owner. A stocker uniquement cote serveur.',
				defaultRole: 'Valeur de role/RBAC assignee a l\'auth-user.',
			},
		},
		console: {
			...en.getStarted.console,
			launching: 'Demarrage AuthFlow™ Linux Console v1.0 ...',
			connected: 'Connecte a api.authflow.net',
			sending: '> Envoi {method} {path}',
			waiting: '> Attente de reponse ...',
			processExited: '[process termine avec le code {code}]',
			status: {
				...en.getStarted.console.status,
				defaultSuccess: 'HTTP/1.1 200 OK (exemple)',
				signup: { ...en.getStarted.console.status.signup, success: 'HTTP/1.1 201 Created (exemple)', alt409: '# alt: HTTP/1.1 409 Conflict quand email+role existe deja' },
				login: { ...en.getStarted.console.status.login, success: 'HTTP/1.1 200 OK (exemple)', alt2fa: '# alt: retourne payload requires2FA/tempToken quand 2FA est activee' },
				verifyEmail: { ...en.getStarted.console.status.verifyEmail, success: 'HTTP/1.1 200 OK (exemple)', alt401: '# alt: HTTP/1.1 401 Unauthorized pour token de verification invalide ou expire' },
				validate: { ...en.getStarted.console.status.validate, success: 'HTTP/1.1 200 OK (exemple)', alt401: '# alt: HTTP/1.1 401 Unauthorized pour session token invalide ou expire' },
				forgotPassword: { ...en.getStarted.console.status.forgotPassword, success: 'HTTP/1.1 200 OK (reponse anti-enumeration)' },
				changePassword: { ...en.getStarted.console.status.changePassword, success: 'HTTP/1.1 200 OK (exemple)', noJsonBody: '# pas de body JSON en cas de succes' },
			},
			failure: {
				...en.getStarted.console.failure,
				signup: { ...en.getStarted.console.failure.signup, status: 'HTTP/1.1 409 Conflict (exemple)', extra: '# scenario echec: email+role en doublon' },
				login: { ...en.getStarted.console.failure.login, status: 'HTTP/1.1 400 Bad Request (exemple)', extra: '# scenario echec: identifiants invalides ou role mismatch' },
				verifyEmail: { ...en.getStarted.console.failure.verifyEmail, status: 'HTTP/1.1 401 Unauthorized (exemple)', extra: '# scenario echec: token de verification obselete' },
				validate: { ...en.getStarted.console.failure.validate, status: 'HTTP/1.1 401 Unauthorized (exemple)', extra: '# scenario echec: session token expire' },
				me: { ...en.getStarted.console.failure.me, status: 'HTTP/1.1 401 Unauthorized (exemple)', extra: '# scenario echec: sessionToken manquant ou invalide' },
				logout: { ...en.getStarted.console.failure.logout, status: 'HTTP/1.1 401 Unauthorized (exemple)', extra: '# scenario echec: sessionToken invalide' },
				changePassword: { ...en.getStarted.console.failure.changePassword, status: 'HTTP/1.1 401 Unauthorized (exemple)', extra: '# scenario echec: oldPassword invalide ou session expiree' },
				resendVerifyEmail: { ...en.getStarted.console.failure.resendVerifyEmail, status: 'HTTP/1.1 401 Unauthorized (exemple)', extra: '# scenario echec: foobar token obselete ou api_key invalide' },
				fooBar: { ...en.getStarted.console.failure.fooBar, status: 'HTTP/1.1 400 Bad Request (exemple)', extra: '# scenario echec: identity ou api_key manquant' },
				forgotPassword: { ...en.getStarted.console.failure.forgotPassword, status: 'HTTP/1.1 400 Bad Request (exemple)', extra: '# scenario echec: email ou api_key manquant' },
				resetPassword: { ...en.getStarted.console.failure.resetPassword, status: 'HTTP/1.1 401 Unauthorized (exemple)', extra: '# scenario echec: reset token obselete' },
				default: { ...en.getStarted.console.failure.default, status: 'HTTP/1.1 400 Bad Request (exemple)', extra: '# scenario echec' },
			},
		},
		pageContent: {
			...en.getStarted.pageContent,
			badge: 'Reference produit auth',
			title: 'Documentation API AuthFlow™',
			titleAccent: 'pour proprietaires d\'organisation',
			description: 'Cette page Get Started documente notre API auth publique pour les utilisateurs de votre organisation. AuthFlow™ fournit 20 routes /auth au total.',
			downloadCollection: 'Telecharger la collection Insomnia',
			createAccount: 'Creer un compte owner',
			cloneStarterOnGitHub: 'Cloner le starter Next.js',
			starterInfoLabel: 'Informations de securite importantes sur le starter Next.js',
			starterWarningTitle: 'Reserve aux prototypes et preuves de concept',
			starterWarningPrototype: 'Le projet authflow-nextjs-starter est destine uniquement aux prototypes et aux frontends de preuve de concept. Ce n\'est pas une integration navigateur de production.',
			starterWarningSecret: 'Ne placez jamais une cle API AuthFlow dans du code frontend de production, des variables d\'environnement visibles par le navigateur, des ressources statiques ou des bundles client. Tout contenu livre a un navigateur peut etre lu par les utilisateurs et les attaquants.',
			starterWarningProduction: 'En production, faites transiter les requetes d\'authentification par un backend serveur de confiance ou par le proxy ExpressJS AuthFlow, et conservez la cle API dans des variables d\'environnement serveur ou un gestionnaire de secrets.',
			apiKeyWarningTitle: 'N\'exposez jamais votre cle API AuthFlow dans du code navigateur de production.',
			apiKeyWarningBody: 'Les cles API doivent rester sur une infrastructure que vous controlez. Ne les integrez pas dans des bundles JavaScript, du HTML, des variables d\'environnement publiques, des ressources web mobiles, des logs ou des requetes reseau envoyees directement par le navigateur. Utilisez ce proxy ExpressJS ou votre propre backend afin que la cle reste cote serveur.',
			integrationRulesTitle: 'Regles d\'integration',
			integrationRulesRules: ['Les owners appellent AuthFlow™ uniquement depuis du code serveur.', 'La cle API owner est requise pour les routes coeur de session.', 'Recuperez fooBar juste avant chaque sign-up/login.', 'Si login renvoie requires2FA, terminez un des echanges /auth/2fa documentes.'],
			ownerAssetsTitle: 'Ressources owner',
			ownerAssetsText: 'Utilisez la collection exacte que votre equipe peut importer dans Insomnia.',
			collectionIncludes: 'La collection inclut :',
			collectionItems: ['7 routes session publiques /auth', '3 routes passwordManagement publiques /auth', '2 routes emailVerification publiques /auth', '8 routes publiques /auth/2fa', 'Variables d\'environnement pour API key, role/RBAC, session token, TOTP, temp token et recovery code'],
			checklistTitle: 'Checklist d\'implementation',
			checklistSubtitle: 'Workflow recommande pour connecter l\'authentification de votre organisation avec AuthFlow™.',
			configStep: '1. Configurer les secrets cote serveur',
			implementStep: '2. Implementer l\'auth cote serveur',
			connectStep: '3. Connecter votre frontend',
			connectStepSecurityNote: 'Votre code navigateur ne doit jamais stocker de secrets API AuthFlow™, comme la cle owner.',
			implementStepRules: ['Appeler /auth/fooBar', 'Appeler /auth/signUp ou /auth/login', 'Stocker les session tokens de facon securisee', 'Utiliser /auth/validate, /auth/me, /auth/changePassword et /auth/logout sur les routes protegees'],
			connectStepRules: ['Soumettre les formulaires login et signup', 'Gerer les prompts 2FA quand l\'API renvoie requires2FA', 'Stocker les sessions applicatives dans des cookies securises', 'Charger l\'utilisateur courant via les reponses des endpoints session'],
			sessionEndpointsTitle: 'Endpoints session',
			sessionEndpointsSubtitle: 'Ces sept routes correspondent a authProduct.session du endpoint root backend.',
			passwordMgmtTitle: 'Endpoints gestion mot de passe',
			passwordMgmtSubtitle: 'Ces trois routes correspondent a authProduct.passwordManagement.',
			emailVerificationTitle: 'Endpoints verification e-mail',
			emailVerificationSubtitle: 'Ces deux routes correspondent a authProduct.emailVerification.',
			twoFactorTitle: 'Endpoints double facteur',
			twoFactorSubtitle: 'Ces huit routes correspondent a authProduct.twoFactor.',
			serviceExampleTitle: 'Exemple de service',
			securityRequirementsTitle: 'Exigences de securite',
			securityRequirements: ['Conservez AUTHFLOW_API_KEY cote serveur et chiffre.', 'Preferez des cookies HTTP-only securises pour les sessions applicatives.', 'Validez les sessions AuthFlow™ avant de servir des donnees protegees.', 'Gerez explicitement les reponses 400, 401, 404, 409 et 500.'],
			readyCtaTitle: 'Pret a connecter l\'authentification de votre entreprise?',
			readyCtaDescription: 'Commencez avec la collection telechargeable, implementez une integration securisee et utilisez l\'assistant de cette page si besoin.',
			proxyDescriptionPrefix: 'Vous pouvez aussi proxifier le backend AuthFlow via votre backend ExpressJS. C\'est l\'une des approches les plus sures pour consommer ',
			proxyDescriptionSuffix: ' dans vos stacks applicatifs.',
			proxyDetailsRoutes: 'Le proxy transfere toutes les routes AuthFlow /auth/* et /auth/2fa/*, conserve la cle API server-side et reduit l\'exposition des secrets navigateur.',
			proxyDetailsDeploy: 'Le proxy est Vercel-ready, supporte le dev local immediatement et inclut des exemples pratiques pour sign-up, login, password flows et verification 2FA.',
			proxyButton: 'Voir sur GitHub',
		},
	},
	comparisons: {
		...en.comparisons,
		hub: {
			...en.comparisons.hub,
			breadcrumbRoot: 'Comparer',
			breadcrumbCurrent: 'Comparatifs produits auth',
			title: 'Comparatifs produits auth',
			description: 'Voyez comment AuthFlow™ se positionne face aux plateformes d\'authentification les plus populaires. Des tableaux comparatifs clairs vous aident a choisir la bonne couche auth pour votre projet.',
			card: {
				firebase: {
					title: 'Firebase vs. Auth0 vs. AuthFlow™',
					description: 'Comparez Firebase Authentication de Google, la plateforme enterprise d\'Auth0 et l\'approche orientee developpeurs d\'AuthFlow™. Vous voyez rapidement quelle solution s\'integre le mieux a votre stack.',
				},
				supabase: {
					title: 'Supabase vs. Auth0 vs. AuthFlow™',
					description: 'Comparez l\'auth open source de Supabase, l\'offre enterprise d\'Auth0 et le service d\'authentification cible d\'AuthFlow™. Ideal si vous travaillez deja dans l\'ecosysteme Supabase.',
				},
			},
			bullets: {
				core: 'Fonctions auth essentielles et securite',
				rbac: '2FA, RBAC et multi-tenance',
				supabaseModel: 'Open source vs. gere vs. specialise',
				pricing: 'Tarification et verrouillage fournisseur',
				dx: 'Experience developpeur et complexite de mise en place',
			},
			viewComparison: 'Voir le comparatif',
		},
		labels: {
			...en.comparisons.labels,
			fullySupported: 'Entierement pris en charge',
			partial: 'Partiel / limite',
			notSupported: 'Non pris en charge',
			feature: 'Fonctionnalite',
			summary: 'Resume',
			startFree: 'Demarrer gratuitement avec AuthFlow™',
			alsoSee: 'Voir aussi :',
			providers: {
				firebase: 'Firebase Auth',
				supabase: 'Supabase Auth',
				auth0: 'Auth0',
				authflow: 'AuthFlow™',
			},
			categories: {
				...en.comparisons.labels.categories,
				core: 'Authentification coeur',
				security: 'Securite',
				userOrg: 'Gestion utilisateurs & organisations',
				dx: 'Experience developpeur',
				pricing: 'Tarification & flexibilite',
			},
		},
		features: {
			emailPassword: 'Authentification e-mail et mot de passe',
			socialLogin: 'Connexion sociale (Google, GitHub, etc.)',
			magicLinks: 'Liens magiques / sans mot de passe',
			smsPhone: 'Authentification SMS / telephone',
			anonymous: 'Authentification anonyme',
			jwt: 'Gestion des tokens JWT',
			rs512: 'Signature par paire de cles RS512',
			twofa: 'Authentification a deux facteurs (2FA)',
			totp: 'Application TOTP (Google Auth, Authy)',
			backupCodes: 'Codes de secours 2FA',
			emailOtp: '2FA via OTP e-mail',
			rateLimiting: 'Limitation de debit',
			emailVerification: 'Verification e-mail',
			passwordReset: 'Reinitialisation / oubli du mot de passe',
			passwordComplexity: 'Regles de complexite du mot de passe',
			userDashboard: 'Tableau de bord de gestion des utilisateurs',
			rbac: 'Controle d\'acces base sur les roles (RBAC)',
			multiTenancy: 'Multi-tenance / Organisations',
			perOrgApiKeys: 'Cles API par organisation',
			auditLogs: 'Journaux d\'audit / d\'activite',
			userBlocking: 'Blocage / suspension des utilisateurs',
			simpleRest: 'API REST simple (sans SDK)',
			officialSdks: 'SDK clients officiels',
			customEmailTemplates: 'Modeles d\'e-mails personnalises',
			webhooks: 'Webhooks / callbacks d\'evenements',
			selfHosted: 'Option self-hosted',
			openSource: 'Open source',
			apiDocs: 'Documentation API',
			integratedDb: 'Base de donnees integree (PostgreSQL)',
			authOnly: 'Auth uniquement (sans base de donnees requise)',
			freeTier: 'Offre gratuite disponible',
			flatRate: 'Tarification forfaitaire previsible',
			payPerMau: 'Modele de facturation par MAU',
			lowLockIn: 'Faible verrouillage fournisseur',
			lowSetup: 'Faible complexite de mise en place',
			noEcosystemBuyIn: 'Fonctionne sans adhesion a un ecosysteme',
		},
		notes: {
			firebase2fa: 'Firebase exige une mise a niveau vers Identity Platform pour activer la 2FA.',
			firebaseRest: 'Firebase est d\'abord concu pour les SDK ; en REST brut, il faut gerer l\'echange de tokens a la main.',
			firebaseLockIn: 'Firebase est fortement lie a l\'ecosysteme Google/Firebase.',
			supabaseRls: 'Supabase s\'appuie sur des politiques Row-Level Security (RLS) dans Postgres.',
			supabaseDb: 'Supabase Auth est etroitement integre a sa base Postgres.',
			supabaseLockIn: 'L\'open source reduit le lock-in, mais l\'auth reste liee a la pile Postgres.',
			supabaseAuthOnly: 'Supabase peut etre utilise seulement pour l\'auth, mais il est pense comme une plateforme backend complete.',
		},
		firebase: {
			...en.comparisons.firebase,
			breadcrumbCurrent: 'Firebase vs. Auth0 vs. AuthFlow™',
			title: 'Firebase vs. Auth0 vs. AuthFlow™',
			description: 'Un comparatif direct entre Google Firebase Authentication, Okta Auth0 et AuthFlow™ afin de choisir la bonne couche auth pour votre application.',
			summary: {
				firebaseTitle: 'Firebase Authentication',
				firebaseBody: 'Ideal pour les equipes deja bien engagees dans l\'ecosysteme Google/Firebase. L\'offre gratuite est genereuse et l\'integration via SDK est pratique, mais le lock-in est fort et les fonctions avancees comme la 2FA exigent Identity Platform.',
				auth0Title: 'Auth0',
				auth0Body: 'Le jeu de fonctionnalites le plus complet des trois : SAML, OIDC, SSO enterprise et personnalisation poussee. Tres bon choix pour les grandes equipes avec des besoins enterprise, mais la tarification grimpe vite avec les MAU.',
				authflowTitle: 'AuthFlow™',
				authflowBody: 'Le bon choix pour les equipes qui veulent une authentification e-mail/mot de passe securisee avec RS512 JWT, 2FA et RBAC sans se lier a un gros ecosysteme. API REST simple, tarification previsible et faible complexite de mise en place.',
			},
			alsoSee: 'Supabase vs. Auth0 vs. AuthFlow™',
		},
		supabase: {
			...en.comparisons.supabase,
			breadcrumbCurrent: 'Supabase vs. Auth0 vs. AuthFlow™',
			title: 'Supabase vs. Auth0 vs. AuthFlow™',
			description: 'Un comparatif direct entre Supabase Auth, Auth0 et AuthFlow™ afin de choisir la bonne couche auth pour votre application.',
			summary: {
				supabaseTitle: 'Supabase Auth',
				supabaseBody: 'Tres pertinent pour les equipes qui veulent un backend open source auto-hebergeable. Supabase Auth offre la connexion sociale, les magic links et une integration profonde avec Postgres, surtout si vous utilisez deja Supabase comme base.',
				auth0Title: 'Auth0',
				auth0Body: 'L\'offre la plus complete avec SAML, OIDC, SSO enterprise et personnalisation poussee. Une valeur sure pour les grandes equipes avec des exigences de conformite, mais un cout qui augmente fortement avec les utilisateurs actifs mensuels.',
				authflowTitle: 'AuthFlow™',
				authflowBody: 'Le bon choix quand vous avez besoin d\'une authentification e-mail/mot de passe ciblee et fiable avec RS512 JWT, 2FA et RBAC sans verrouillage de plateforme. API REST simple, prix forfaitaire previsible et configuration minimale.',
			},
			alsoSee: 'Firebase vs. Auth0 vs. AuthFlow™',
		},
	},
	features: {
		title: 'Pourquoi AuthFlow™ est different',
		description: 'Nous nous concentrons sur l\'authentification e-mail/mot de passe avec des tokens JWT - la base des applications web securisees. Au lieu de tout faire, nous faisons une chose extremement bien.',
		emailPassword: {
			title: 'Connexion e-mail/mot de passe',
			description: 'Une authentification e-mail/mot de passe simple et sure qui fonctionne de facon fiable. Pas de flux complexes ni de fonctionnalites inutiles.',
		},
		jwtTokens: {
			title: 'Gestion des tokens JWT',
			description: 'Gestion correcte des tokens JWT pour les sessions, avec stockage securise et rafraichissement automatique. Des tokens standards qui s\'integrent facilement a votre API.',
		},
		developerApi: {
			title: 'API orientee developpeurs',
			description: 'API REST avec documentation complete, SDK et outils pour developpeurs. Concue par des developpeurs pour le workflow DevSecOps.',
		},
	},
	testimonials: {
		title: 'Approuve par des developpeurs dans le monde entier',
		testimonial1: {
			text: 'AuthFlow™ nous a fait gagner des mois de developpement. L\'integration a ete fluide et les fonctions de securite sont de niveau enterprise.',
			author: 'Sarah Johnson',
			role: 'CTO, TechStart',
		},
		testimonial2: {
			text: 'Le tableau de bord analytique nous donne des informations precieuses sur le comportement des utilisateurs. Meilleure solution auth que nous ayons utilisee.',
			author: 'Mike Rodriguez',
			role: 'Lead Developer, AppCorp',
		},
		testimonial3: {
			text: 'Fiabilite exemplaire et excellent support. Nos utilisateurs adorent l\'experience d\'authentification fluide.',
			author: 'Alex Liu',
			role: 'Product Manager, InnovateLab',
		},
	},
	signIn: {
		title: 'Bon retour',
		subtitle: 'Connectez-vous a votre authentification e-mail/mot de passe',
		card: {
			title: 'Connexion organisation',
			description: 'Saisissez l\'e-mail du proprietaire de l\'organisation pour acceder au tableau de bord JWT',
		},
		form: {
			email: { label: 'E-mail', placeholder: 'owner@votreorganisation.com' },
			password: { label: 'Mot de passe', placeholder: 'Entrez votre mot de passe' },
			signIn: 'Se connecter',
			signingIn: 'Connexion en cours...',
			noAccount: { text: 'Pas encore d\'organisation?', link: 'En creer une' },
		},
		errors: {
			emailRequired: 'L\'e-mail est requis',
			failed: 'Echec de connexion',
			unexpected: 'Une erreur inattendue est survenue. Veuillez reessayer.',
		},
		success: { message: 'Connexion reussie !' },
		agreement: {
			text: 'En vous connectant, vous acceptez nos',
			terms: 'Conditions d\'utilisation',
			and: 'et',
			privacy: 'Politique de confidentialite',
		},
	},
	signUp: {
		title: 'Creez votre organisation',
		subtitle: 'Demarrez votre organisation avec l\'authentification e-mail/mot de passe',
		card: {
			title: 'Creer une organisation',
			description: 'Configurez votre organisation pour commencer avec l\'authentification e-mail/mot de passe et les tokens JWT',
		},
		form: {
			organizationName: { label: 'Nom de l\'organisation', placeholder: 'Votre Organisation' },
			organizationWebsite: { label: 'Site web de l\'organisation', placeholder: 'votreorganisation.com' },
			emailOwner: { label: 'E-mail du proprietaire', placeholder: 'owner@votreorganisation.com' },
			password: { label: 'Mot de passe', placeholder: 'Creez un mot de passe fort' },
			confirmPassword: { label: 'Confirmer le mot de passe', placeholder: 'Confirmez votre mot de passe' },
			agreeToTerms: 'J\'accepte les Conditions d\'utilisation et la Politique de confidentialite',
			acceptMarketing: 'Envoyez-moi les mises a jour produit et e-mails marketing',
			createOrganization: 'Creer l\'organisation',
			creatingOrganization: 'Creation de l\'organisation...',
			haveAccount: { text: 'Vous avez deja un compte?', link: 'Se connecter' },
		},
		errors: {
			organizationNameRequired: 'Le nom de l\'organisation est requis',
			organizationWebsiteRequired: 'Le site web de l\'organisation est requis',
			emailRequired: 'L\'e-mail est requis',
			passwordRequired: 'Le mot de passe est requis',
			passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
			agreeToTermsRequired: 'Vous devez accepter les Conditions d\'utilisation et la Politique de confidentialite',
			failed: 'Echec de creation de l\'organisation',
			unexpected: 'Une erreur inattendue est survenue. Veuillez reessayer.',
		},
		success: { message: 'Organisation creee avec succes !' },
		trial: {
			description: 'Commencez a gerer l\'authentification de votre organisation des aujourd\'hui.',
			features: {
				emailPassword: 'Authentification e-mail/mot de passe',
				jwtTokens: 'Securite des tokens JWT',
				simpleLogin: 'Connexion simple',
			},
		},
	},
	common: {
		loading: 'Chargement...',
		error: 'Une erreur est survenue',
		success: 'Succes',
		cancel: 'Annuler',
		save: 'Enregistrer',
		delete: 'Supprimer',
		edit: 'Modifier',
		view: 'Voir',
		back: 'Retour',
		next: 'Suivant',
		previous: 'Precedent',
		language: 'Langue',
	},
	seo: {
		title: 'AuthFlow™ - L\'authentification securisee simplifiee',
		description: 'Authentification basee sur des tokens pour les applications web. Integration facile, securite enterprise et API concue pour les developpeurs. Commencez votre essai gratuit aujourd\'hui.',
		keywords: ['authentification', 'auth', 'securite', 'API', 'auth basee sur tokens', 'JWT', 'outils developpeur', 'securite web', 'gestion des utilisateurs'],
	},
	footer: {
		description: 'Authentification e-mail/mot de passe simple et fiable avec tokens JWT. Approuvee par des developpeurs dans le monde entier.',
		product: 'Produit',
		resources: 'Ressources',
		company: 'Entreprise',
		apiReference: 'Reference API',
		about: 'A propos',
		support: 'Support',
		privacyPolicy: 'Politique de confidentialite',
		termsOfService: 'Conditions d\'utilisation',
		copyright: '© 2024 AuthFlow™. Tous droits reserves.',
	},
	pricing: {
		title: 'Tarifs AuthFlow™ - Cout simple de l\'authentification e-mail/mot de passe',
		description: 'Tarification simple et transparente pour l\'authentification e-mail/mot de passe avec tokens JWT. Demarrez gratuitement puis evoluez sans frais caches.',
		keywords: ['tarif authentification', 'tarif email mot de passe', 'tarif JWT', 'tarification auth simple', 'tarification auth developpeur', 'cout auth fiable', 'tarif connexion securisee', 'tarif auth token', 'essai gratuit auth'],
		ogTitle: 'Tarifs AuthFlow™ - Cout simple de l\'authentification e-mail/mot de passe',
		ogDescription: 'Choisissez le plan ideal. Demarrez gratuitement et evoluez avec une authentification e-mail/mot de passe fiable et JWT.',
		hero: {
			title: 'Tarification simple et',
			titleAccent: 'transparente',
			description: 'Choisissez le plan adapte a vos besoins d\'authentification. Demarrez gratuitement puis evoluez avec l\'authentification e-mail/mot de passe via tokens de session JWT.',
		},
		breadcrumb: { product: 'Produit', pricing: 'Tarifs' },
		plans: {
			starter: {
				name: 'Starter',
				description: 'Parfait pour les petits projets et les tests d\'authentification e-mail/mot de passe',
				price: '$0',
				period: '/mois',
				features: {
					users: 'Jusqu\'a 10 utilisateurs actifs mensuels',
					basicAuth: 'Authentification e-mail/mot de passe de base',
					support: 'Support standard',
				},
				cta: 'Commencer gratuitement',
			},
			pro: {
				name: 'Pro',
				description: 'Pour les entreprises en croissance qui ont besoin d\'une authentification fiable',
				price: '$9.99',
				period: 'premier mois, puis $19.99/mois',
				badge: 'Le plus populaire',
				features: {
					users: 'Utilisateurs actifs mensuels illimites',
					advancedAuth: 'Authentification e-mail/mot de passe avancee',
					support: 'Support prioritaire',
				},
				cta: 'Demarrer l\'essai gratuit',
				monthlyCta: 'Acheter mensuel',
				annualCta: 'Acheter annuel',
			},
		},
		faq: {
			title: 'Questions frequentes',
			subtitle: 'Tout ce que vous devez savoir sur nos tarifs et plans d\'authentification e-mail/mot de passe.',
			questions: {
				mau: { question: 'Qu\'est-ce qu\'un utilisateur actif mensuel ?', answer: 'Un utilisateur actif mensuel (MAU) est un utilisateur unique qui s\'authentifie au moins une fois sur un mois calendaire.' },
				changePlans: { question: 'Puis-je changer de plan a tout moment ?', answer: 'Oui, vous pouvez changer de plan a tout moment. Les changements sont immediats et la facturation est au prorata.' },
				freeTrial: { question: 'Y a-t-il un essai gratuit ?', answer: 'Oui, tous les plans payants incluent un essai gratuit de 3 jours. Aucune carte bancaire requise.' },
				paymentMethods: { question: 'Quels moyens de paiement acceptez-vous ?', answer: 'Nous acceptons les principales cartes bancaires, Google Pay et Apple Pay.' },
			},
		},
		cta: {
			title: 'Pret a commencer ?',
			description: 'Rejoignez des milliers de developpeurs qui font confiance a AuthFlow™ pour une authentification fiable. Demarrez votre essai gratuit aujourd\'hui.',
			startTrial: 'Demarrer l\'essai gratuit',
			contactSales: 'Contacter les ventes',
		},
		footer: {
			description: 'Authentification e-mail/mot de passe simple et fiable avec tokens JWT. Approuvee par des developpeurs dans le monde entier.',
			product: { title: 'Produit', features: 'Fonctionnalites', pricing: 'Tarifs', apiReference: 'Reference API' },
			resources: { title: 'Ressources', gettingStarted: 'Demarrage', apiReference: 'Reference API', support: 'Support' },
			company: { title: 'Entreprise', about: 'A propos', privacy: 'Politique de confidentialite', terms: 'Conditions d\'utilisation' },
			copyright: '© 2024 AuthFlow™. Tous droits reserves.',
		},
	},
	agent: {
		chatbot: {
			title: 'Assistant AuthFlow™',
			inputPlaceholder: 'Posez une question sur /auth ou l\'integration 2FA...',
			greeting: 'Je guide les proprietaires d\'organisation a travers le contrat exact AuthFlow™ auth-user. Demandez-moi la configuration de la cle API owner, les endpoints /auth, les flux 2FA, la collection Insomnia, la frontiere frontend-backend ou la suppression de compte depuis Settings.',
			downloadIntro: 'Utilisez cette carte de telechargement direct pour recuperer la collection owner que votre equipe peut importer immediatement.',
			downloadTitle: 'Telecharger les collections Insomnia',
			downloadButton: 'Telecharger',
			noAnswer: 'Je n\'ai pas recu de reponse exploitable de l\'agent. Posez une question sur un endpoint precis, un flux 2FA ou une etape d\'integration backend.',
			error: 'Une erreur est survenue lors de la connexion a l\'assistant. Vous pouvez toujours demander des informations sur le contrat /auth, les flux 2FA ou la collection Insomnia et reessayer.',
			toolNotFound: 'Outil introuvable',
		},
		tools: {
			verificationRecoveryDescription: 'Endpoints de verification email et de recuperation de mot de passe',
			accountSteps: ['1. Inscrivez-vous comme proprietaire d\'organisation sur https://www.authflow.net/sign-up', '2. Creez l\'organisation dans le tableau de bord owner', '3. Copiez la cle API de l\'organisation depuis le tableau de bord', '4. Definissez les valeurs de role pour vos utilisateurs auth', '5. Telechargez la collection Insomnia auth-user AuthFlow™', '6. Fournissez la collection et le contrat backend exact a l\'equipe d\'integration'],
			accountManagement: ['Pour supprimer definitivement une organisation, allez sur la page Settings du tableau de bord AuthFlow™.', 'Utilisez la section Delete Account et saisissez DELETE pour confirmer la suppression irreversible.'],
			reminder: 'La cle API owner doit rester uniquement sur le backend de l\'entreprise.',
			environmentNotes: ['Conservez AUTHFLOW_API_KEY uniquement cote serveur.', 'AUTHFLOW_DEFAULT_ROLE est optionnel mais utile.', 'Le frontend doit appeler vos propres routes backend, pas AuthFlow™ directement.'],
			backendGuidance: ['Recuperez /auth/fooBar juste avant /auth/signUp ou /auth/login.', 'Utilisez exactement les noms de parametres du contrat public.', 'Si /auth/login renvoie requires2FA, poursuivez avec la route /auth/2fa appropriee.', 'Validez et chargez l\'utilisateur courant via le backend, puis exposez uniquement votre session applicative au frontend.'],
			insomniaContains: ['Les 12 endpoints publics /auth (y compris verify-email, resend-verify-email, forgot-password, reset-password, deleteUser)', 'Les 8 endpoints publics /auth/2fa', 'Variables d\'environnement pour API key, role, token fooBar, tempToken, token de session, TOTP, OTP email et codes de recuperation'],
			troubleshoot: {
				solutions: {
					cors: 'Si le navigateur appelle AuthFlow™ directement, arretez ici. Le navigateur doit appeler votre backend, et votre backend doit appeler AuthFlow™.',
					'401_unauthorized': 'Verifiez que api_key, role et email correspondent exactement aux valeurs utilisees pour /auth/fooBar ou la creation utilisateur.',
					token_validation: 'Pour /auth/validate, utilisez exactement la paire sessionToken + email et ne confondez pas avec tempToken.',
					connection_failed: 'Verifiez AUTHFLOW_BASE_URL = https://api.authflow.net et la connectivite du backend.',
					api_key_invalid: 'La cle API owner doit etre la cle dashboard commencant par af_.',
					foobar_expired: 'fooBar expire vite. Regenerer juste avant sign-up/login.',
					verification_link: 'Le token de verification email doit etre valide et passe en query a /auth/verify-email.',
					password_reset: 'Appelez d\'abord /auth/forgot-password puis /auth/reset-password avec le token recu par email.',
					two_factor_flow: 'Si login renvoie requires2FA, utilisez tempToken uniquement avec les routes /auth/2fa.',
					organization_deletion: 'La suppression permanente d\'organisation se fait dans Settings > Delete Account avec DELETE.',
					other: 'Comparez la requete au contrat public: noms de parametres, methode HTTP et emplacement query/body/header.',
				},
				commonIssues: ['Frontend appelant AuthFlow™ directement', 'api_key manquante ou role incorrect sur /auth/fooBar ou /auth/login', 'Mauvaise utilisation de oldPassword/newPassword sur /auth/changePassword', 'Confusion entre tempToken et sessionToken', 'Token de verification expire ou invalide', 'Absence de /auth/forgot-password avant /auth/reset-password', 'Echange 2FA saute apres requires2FA', 'Tentative de suppression d\'organisation hors du flux Settings'],
			},
		},
	},
} as const
